export class CreProUserSharingPostReq {
    userID?: number | null;
    Permission?: string | null;
}
  